import { render, staticRenderFns } from "./categoryRegionSelect.vue?vue&type=template&id=0d7ff269&scoped=true&"
import script from "./categoryRegionSelect.vue?vue&type=script&lang=js&"
export * from "./categoryRegionSelect.vue?vue&type=script&lang=js&"
import style0 from "./categoryRegionSelect.vue?vue&type=style&index=0&id=0d7ff269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ff269",
  null
  
)

export default component.exports